import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	mode: "history",
	routes: [{
			path: '/',
			name: 'index',
			component: () =>
				import('@/pages/index'),
			meta: {
				nav: true,
				nokeep: true,
				exact: false
			}
		},
		{
			path: '/courseInfo',
			name: 'courseInfo',
			component: () =>
				import('@/pages/week/infos'),
			meta: {
				nav: true,
				nokeep: true,
				exact: true
			}
		},
		{
			path: '/yinsi',
			name: 'yinsi',
			component: () =>
				import('@/pages/yinsi'),
			meta: {
				nav: false,
				nokeep: true,
				exact: true,
				foots: 1
			}
		},
		{
			path: '/memory',
			name: 'memory',
			component: () =>
				import('@/pages/memory/memory'),
			meta: {
				nav: true,
				nokeep: true,
				exact: true
			}
		},
		{
			path: '/memory_info',
			name: 'memory_info',
			component: () =>
				import('@/pages/memory/memory_info'),
			meta: {
				nav: true,
				nokeep: true,
				exact: true
			}
		},
		{
			path: '/writing_practice',
			name: 'writing_practice',
			component: () =>
				import('@/pages/writing_practice/writing_practice'),
			meta: {
				nav: true,
				nokeep: false,
				exact: true
			}
		},
		{
			path: '/writing_practiceinfo',
			name: 'writing_practiceinfo',
			component: () =>
				import('@/pages/writing_practice/infos'),
			meta: {
				nav: true,
				nokeep: false,
				exact: true
			}
		},
		{
			path: '/writing_practiceinfo1',
			name: 'writing_practiceinfo1',
			component: () =>
				import('@/pages/writing_practice/infos1'),
			meta: {
				nav: true,
				nokeep: false,
				exact: true
			}
		},
		{
			path: '/package_test',
			name: 'package_test',
			component: () =>
				import('@/pages/package_test/package_test'),
			meta: {
				nav: true,
				nokeep: true,
				exact: true
			}
		},
		{
			path: '/package_test1',
			name: 'package_test1',
			component: () =>
				import('@/pages/package_test/package_test1'),
			meta: {
				nav: false,
				nokeep: true,
				exact: true
			}
		},{
			path: '/my_note',
			name: 'my_note',
			component: () =>
				import('@/pages/userinfo/my_note'),
			meta: {
				nav: true,
				nokeep: true,
				exact: true
			},
		}, 
		{
			path: '/onlinevideo',
			name: 'onlinevideo',
			component: () =>
				import('@/pages/onlinevideo/onlinevideo'),
				meta: {
					nav: true,
					nokeep: true,
					exact: true
				},
		},
		{
			path: '/video',
			name: 'video',
			component: () =>
				import('@/pages/video/video'),
				meta: {
					nav: true,
					nokeep: true,
					exact: true
				},
		}, {
			path: '/videoinfo',
			name: 'videoinfo',
			component: () =>
				import('@/pages/video/video_info'),
			meta: {
				nav: true,
				nokeep: true,
				exact: true
			}
		},
		{
			path: '/homework',
			name: 'homework',
			component: () =>
				import('@/pages/homework/homework'),
			meta: {
				nav: true,
				nokeep: true,
				exact: true
			}
		},
		{
			path: '/homeworkInfo',
			name: 'homeworkInfo',
			component: () =>
				import('@/pages/homework/info'),
			meta: {
				nav: true,
				nokeep: true,
				exact: true
			}
		},
		{
			path: '/userinfo',
			name: 'userinfo',
			component: () =>
				import('@/pages/userinfo/userinfo'),
			meta: {
				nav: true,
				nokeep: true,
				exact: true
			}
		},
		{
			path: '/userinfo_collect',
			name: 'userinfo_collect',
			component: () =>
				import('@/pages/userinfo/userinfo_collect'),
			meta: {
				nav: true,
				nokeep: true,
				exact: true
			}
		},
		{
			path: '/userinfo_collect_info',
			name: 'userinfo_collect_info',
			component: () =>
				import('@/pages/userinfo/userinfo_collect_info'),
			meta: {
				nav: true,
				nokeep: false,
				exact: true
			}
		},
		{
			path: '/userinfo_studyPlan',
			name: 'userinfo_studyPlan',
			component: () =>
				import('@/pages/userinfo/userinfo_studyPlan'),
			meta: {
				nav: true,
				nokeep: true,
				exact: true
			}
		},
		{
			path: '/vip',
			name: 'vip',
			component: () =>
				import('@/pages/userinfo/vip'),
			meta: {
				nav: true,
				nokeep: true,
				exact: true
			}
		},
		{
			path: '/forum',
			name: 'forum',
			component: () =>
				import('@/pages/forum/forumpage'),
			meta: {
				nav: true,
				nokeep: true,
				exact: true
			}
		},
		{
			path: '/userinfo_studyPlan_ai',
			name: 'userinfo_studyPlan_ai',
			component: () =>
				import('@/pages/userinfo/userinfo_studyPlan_ai'),
			meta: {
				nav: true,
				nokeep: true,
				exact: true
			}
		},
		{
			path: '/userinfo_history_cj',
			name: 'userinfo_history_cj',
			component: () =>
				import('@/pages/userinfo/userinfo_history_cj'),
			meta: {
				nav: true,
				nokeep: true,
				exact: true
			}
		},
		{
			path: '/week',
			name: 'week',
			component: () =>
				import('@/pages/week/week'),
			meta: {
				nav: true,
				nokeep: false,
				exact: true
			}
		},
		{
			path: '/today',
			name: 'today',
			component: () =>
				import('@/pages/today/today'),
			meta: {
				nav: true,
				nokeep: false,
				exact: true
			}
		},
		{
			path: '/Writing_word',
			name: 'Writing_word',
			component: () =>
				import('@/pages/zhentidanci/Writing_word'),
			meta: {
				nav: true,
				nokeep: true,
				exact: true
			},
			children: []
		},
		{
			path: '/Writing_word_info',
			component: () =>
				import('@/pages/zhentidanci/Writing_word_info'),
			meta: {
				nav: true,
				nokeep: true,
				exact: true
			}
		},
		{
			path: '/test_memory',
			name: 'test_memory',
			component: () =>
				import('@/pages/test_memory'),
			meta: {
				nav: true,
				nokeep: true,
				exact: true
			}
		},
		{
			path: '/register',
			name: 'register',
			component: () =>
				import('@/pages/register'),
			meta: {
				nav: false,
				nokeep: true,
				exact: true,
				foots: 1
			}
		},
		{
			path: '/resetting',
			name: 'resetting',
			component: () =>
				import('@/pages/resetting'),
			meta: {
				nav: false,
				nokeep: true,
				exact: true,
				foots: 1
			}
		},
		{
			path: '/test_memory',
			name: 'test_memory',
			component: () =>
				import('@/pages/test_memory'),
			meta: {
				nav: true,
				nokeep: true,
				exact: true
			}
		},

]
})



// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js